<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권 충전</p>
          <ul class="depth">
            <li><router-link to="/webdiscountcharge" title="웹 선불권 충전">웹 선불권 충전</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권 적용">웹 선불권 적용</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle web">웹 선불권 충전</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                웹 선불권 충전 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 125px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">주차장 명</th>
                  <td>
                    <div v-for="(item, index) in parkingInfo" :key="index">
                      {{ item.PARKING_NM }}<span class="colorType blue"> (30분당 {{ pointAmt }}원)</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">현재 잔여 시간</th>
                  <td>{{ timeUserInfo.remainingTime | comma }} 분</td>
                </tr>
                <tr>
                  <th scope="row">충전 시간</th>
                  <td>
                    <div class="dcFlex">
                      <div class="dcInput">
                        <input
                          type="text"
                          title="충전시간 입력"
                          placeholder="예) 60"
                          @input="bindNumber"
                          :value="time"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        />
                        <em>분</em>
                      </div>
                      <button type="button" class="btn gray" @click="clickApplyBtn()">적용</button>
                    </div>
                    <p class="info">30분 단위로 입력하시기 바랍니다.</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">충전 후 선불권 시간 합계</th>
                  <td>
                    <strong class="colorType blue">{{ totalTime | comma }} 분</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
          <p class="info">웹 선불권 시간은 30분 단위로 충전이 가능하며, 30분 당 {{ pointAmt }}원입니다.</p>
          <p class="info">충전한 시간은 환불되지 않으니 반드시 충전 내역과 금액을 확인 후 결제 해 주세요.</p>
        </article>
        <article class="resultBox">
          <div class="result">
            <div class="txt">
              결제금액
              <div class="pay">{{ payment | comma }}</div>
              원
            </div>
            <button type="button" class="btn mint" @click="clickPayMentBtn()">충전시간 결제</button>
          </div>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn gray" @click="CloseBtn">취소</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>

    <form id="tranMgr" name="tranMgr" method="post">
      <input type="hidden" name="PayMethod" v-model="smartropayParms.PayMethod" />
      <input type="hidden" name="GoodsCnt" v-model="smartropayParms.GoodsCnt" />
      <input type="hidden" name="GoodsName" v-model="smartropayParms.goodsName" />
      <input type="hidden" name="Amt" v-model="smartropayParms.amount" />
      <input type="hidden" name="Moid" v-model="smartropayParms.moid" />
      <input type="hidden" name="Mid" v-model="smartropayParms.mid" />
      <input type="hidden" name="ReturnUrl" v-model="smartropayParms.returnUrl" />
      <input type="hidden" name="BuyerName" v-model="smartropayParms.buyerName" />
      <input type="hidden" name="BuyerTel" v-model="smartropayParms.buyerTel" />
      <input type="hidden" name="BuyerEmail" v-model="smartropayParms.BuyerEmail" />
      <input type="hidden" name="MallIp" v-model="smartropayParms.MallIp" />
      <input type="hidden" name="EncryptData" v-model="smartropayParms.encryptData" />
      <input type="hidden" name="EdiDate" v-model="smartropayParms.ediDate" />
      <input type="hidden" name="TaxAmt" v-model="smartropayParms.TaxAmt" />
      <input type="hidden" name="TaxFreeAmt" v-model="smartropayParms.TaxFreeAmt" />
      <input type="hidden" name="VatAmt" v-model="smartropayParms.VatAmt" />
    </form>

    <form id="approvalForm" name="approvalForm" method="post">
      <input type="hidden" id="Tid" name="Tid" />
      <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
    </form>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import AlertMatch from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      time: '',
      resultOther: 0,
      resultCheck: false,
      showModalMsgSuccess: false,
      msg: '',
      payment: 0,
      totalTime: 0,
      timeUserInfo: {},
      parkingInfo: [],
      smartropayParms: {},
      pointAmt: 600,
    };
  },

  components: {
    AlertMatch,
  },

  mounted() {
    this.initView();
  },

  methods: {
    async initView() {
      const res = await axios('get', '/api/time/point', {
        portalId: this.$store.state.empNo,
        empEsntlId: this.$store.state.empEsntlId,
      });
      const data = res.data.result;
      const parkingData = res.data.mappingList;
      if (!data || data.length < 0) {
        this.timeUserInfo = {};
        return;
      } else {
        this.timeUserInfo = data.data;
        this.totalTime = data.data.remainingTime;
      }

      if (!parkingData || parkingData.length < 0) {
        this.parkingInfo = {};
        return;
      } else {
        const parkingIdx = 0;
        this.parkingInfo = parkingData;
        this.pointAmt = this.parkingInfo[parkingIdx].WEB_DISCOUNT_DEFAULT_AMT;
      }
    },
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;
    },

    bindNumber(event) {
      this.time = event.target.value;
    },
    clickApplyBtn() {
      if (this.time != '' && this.time > 0) {
        this.resultOther = parseInt(this.time) % 30;

        if (this.resultOther > 0) {
          this.resultCheck = false;
          this.payment = 0;
          this.time = 0;
          this.totalTime = 0;

          this.msg = '30분단위로만 가능합니다.';
          this.showModalMsgSuccess = true;
        } else {
          this.payment = (parseInt(this.time) / 30) * this.pointAmt;
          this.resultCheck = true;
          this.totalTime = this.timeUserInfo.remainingTime + parseInt(this.time);
        }
      } else {
        this.msg = '공백은 입력이 불가능합니다.';
        this.showModalMsgSuccess = true;
        this.resultCheck = false;
        this.payment = 0;
        this.time = 0;
        this.totalTime = 0;
      }
    },
    async clickPayMentBtn() {
      if (this.resultCheck) {
        let apiParams = new FormData();
        apiParams.append('amount', this.payment);
        apiParams.append('inOutId', 'TIMEDISCOUNT');
        apiParams.append('payCategory', 'TIMEDISCOUNT');
        apiParams.append('isStatus', false);
        apiParams.append('memberInfoId', this.$store.state.empNo);
        apiParams.append('carNumber', this.time);
        apiParams.append('period', '');
        const res = await axios('post', '/api/smartropay/payment', apiParams);
        const { ediDate = '', encryptData = '', mid = '', amount = '', paymentId = '' } = res.data.result;
        const RETURN_URL = `${process.env.VUE_APP_DOMAIN}/api/smartropay/callApproval/webdiscountcharge/${paymentId}`;
        // 부가세 계산 방식
        const TaxFreeAmt = 0;
        const tmp = amount / 1.1;
        const VatAmt = Math.floor(amount - tmp);
        const TaxAmt = amount - VatAmt;
        this.smartropayParms = {
          goodsName: '웹 선불권시간구매',
          amount: amount,
          moid: paymentId,
          mid: mid,
          returnUrl: RETURN_URL,
          StopUrl: RETURN_URL,
          buyerName: this.$store.state.empNm,
          buyerTel: this.$store.state.empMobile,
          encryptData: encryptData,
          ediDate: ediDate,
          TaxAmt: TaxAmt,
          VatAmt: VatAmt,
          TaxFreeAmt: TaxFreeAmt,
          PayMethod: 'CARD',
          GoodsCnt: 1,
          BuyerEmail: 'noname@smartro.co.kr',
          MallIp: '211.57.44.13',
        };
        await smartropay.init({
          mode: process.env.VUE_APP_SMARTRO_INIT,
        });
        await smartropay.payment({
          FormId: 'tranMgr',
          Callback: function (res) {
            var approvalForm = document.approvalForm;
            approvalForm.Tid.value = res.Tid;
            approvalForm.TrAuthKey.value = res.TrAuthKey;
            approvalForm.action = RETURN_URL;
            approvalForm.submit();
          },
        });
      } else {
        this.msg = '적용버튼을 선택해주세요.';
        this.showModalMsgSuccess = true;
      }
    },
  },

  watch: {
    time(val) {
      this.resultCheck = false;

      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;

      // 한글, 영문 체크
      if (reg.exec(val) !== null) this.time = val.replace(/[^0-9]/g, '');

      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) this.time = '';
    },
  },
};
</script>
